import { RootState, TypedDispatch } from "src";
import client from "../../common/client";
import rawr from "../../common/lib/rawr";
import { pushNotification } from "./app";
import { selectValidUserCodes } from "../selectors/property";
import firebase from "../../common/firebase";
import { AccessRequestSource, createNotification } from "src/common/types";

export const getPropertyData = () => {
  return {
    type: "GET_PROPERTY_DATA",
    promise: client.get("telephone-entry/property"),
  };
};

export const sendNewAccessRequestsIfOnline =
  () => (dispatch: TypedDispatch, getState: () => RootState) => {
    const state = getState();
    if (
      state.app.isOnline &&
      state.property?.accessRequests &&
      state.property?.accessRequests?.length > 0
    ) {
      dispatch({
        type: "SEND_ACCESS_REQUESTS",
        promise: client.post("telephone-entry/access-requests", {
          json: { requests: state.property.accessRequests },
        }),
        accessRequests: state.property.accessRequests,
      });
    }
  };

export const enqueueAccessRequest =
  (
    user_code: string | null | undefined,
    access_granted: boolean,
    source?: AccessRequestSource
  ) =>
  (dispatch: TypedDispatch, getState: () => RootState) => {
    const state = getState();
    if (state.property.loaded) {
      // force user_code to string
      user_code = user_code ? String(user_code).padStart(5, "0") : null;
      dispatch({
        type: "ENQUEUE_ACCESS_REQUEST",
        accessRequest: {
          user_code,
          access_granted,
          created_at: new Date().toISOString(),
          source,
        },
      });
      dispatch(sendNewAccessRequestsIfOnline());
    }
  };

export const openGate =
  (code: string | undefined, outputWiegand: boolean = true) =>
  (dispatch: TypedDispatch) => {
    if (!code) {
      console.log("rawr : openGate() called without a code");
    }

    if (rawr) {
      dispatch(
        pushNotification(
          createNotification(
            "SUCCESS",
            "Access Granted!",
            "You can now enter",
            "gateOpen"
          )
        )
      );
      if (code && outputWiegand) {
        rawr.methods.wiegand(0, parseInt(code)).then((result: any) => {
          console.log("rawr : sent wiegand", result);
        });
      }
      setTimeout(() => {
        rawr.methods.enable_relay1().then((result: any) => {
          console.log("rawr : local gate relay 1 triggered", result);
        });
      }, 600);
    }
  };

export const accessDenied =
  (code: string | undefined) => (dispatch: TypedDispatch) => {
    dispatch(
      pushNotification(
        createNotification(
          "ERROR",
          "Sorry, you weren't granted access.",
          null,
          "sorryNoAccess"
        )
      )
    );

    enqueueAccessRequest(code, false);
  };
export const handleWiegandNotification =
  (code: string) => (dispatch: TypedDispatch, getState: () => RootState) => {
    console.log("rawr : onfacility", code);

    const validAccessCodes = selectValidUserCodes(getState());

    const accessCodeValid = validAccessCodes.some(
      (c) => parseInt(c, 10) === parseInt(code, 10)
    );

    if (accessCodeValid) {
      firebase.logAnalyticsEvent("wiegand_gate_unlocked");
      dispatch(openGate(`${code}`, false)); // If code came from reader, do not output wiegand, as it has already been output by the Pic-18
      dispatch(enqueueAccessRequest(code, true));
    } else {
      dispatch(
        pushNotification(
          createNotification(
            "ERROR",
            "Sorry, that code didn't work",
            null,
            null
          )
        )
      );
      dispatch(enqueueAccessRequest(code, false));
    }
  };

export const handleCheckin = () => {
  return {
    type: "SERVER_CHECKIN",
    promise: client.post("telephone-entry/checkin"),
  };
};

export const persistLog = (message: string, ...meta: any) => {
  console.log(message, ...meta);
  return {
    type: "PERSIST_LOG",
    promise: client.post("telephone-entry/logs", {
      json: {
        message,
        meta,
        timestamp: new Date(),
      },
    }),
  };
};
